{
  "Monday": "Lundi",
  "Mondayshort": "Lun",
  "Tuesday": "Mardi",
  "Tuesdayshort": "Mar",
  "Wednesday": "Mercredi",
  "Wednesdayshort": "Mercredi",
  "Thursday": "Jeudi",
  "Thursdayshort": "Jeu",
  "Friday": "Vendredi",
  "Fridayshort": "Fri",
  "Saturday": "Samedi",
  "Saturdayshort": "Sam",
  "Sunday": "Dimanche",
  "Sundayshort": "Soleil",
  "NAME": "DaysOfTheWeek"
}